import { render, staticRenderFns } from "./Kjfd.vue?vue&type=template&id=2a3a48ed&scoped=true"
import script from "./Kjfd.vue?vue&type=script&lang=js"
export * from "./Kjfd.vue?vue&type=script&lang=js"
import style0 from "./Kjfd.vue?vue&type=style&index=0&id=2a3a48ed&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3a48ed",
  null
  
)

export default component.exports